import React, { useState } from "react";
import { Button } from "./ui/button";
import { useParams, useNavigate } from "react-router";
import _ from "lodash";
import { saveAs } from "file-saver";

import Modal from "../Modal";
import { Slider } from "./ui/slider";
import useFirebaseSegments from "../hooks/useFirebaseSegments";
import useFirebaseFiring from "../hooks/useFirebaseFiring";
import useFirebasePreferences from "../hooks/useFirebasePreferences";
import useFirebaseKiln from "../hooks/useFirebaseKiln";
import { generateExportFile } from "../helpers/exportHelpers";

const FiringExportPage = () => {
  const { id, kiln: kilnId } = useParams();
  const navigate = useNavigate();
  const firing = useFirebaseFiring(id!);
  const kiln = useFirebaseKiln(kilnId!);
  const segments = useFirebaseSegments();
  const preferences = useFirebasePreferences();
  const [naberthermProgramNumber, setNaberthermProgramNumber] = useState({
    value: 1,
  });

  const degrees =
    preferences && preferences.degrees ? preferences && preferences.degrees : "celsius";

  const my_segments = _.filter(
    segments,
    (segment) => segment && segment.firing_id === id
  );

  const saveExportedFile = () => {
    const fileContents = generateExportFile(
      firing!,
      my_segments,
      kiln,
      degrees,
      naberthermProgramNumber.value
    );
    const blob = new Blob([fileContents], {
      type: "text/plain; charset=utf-8",
    });
    saveAs(
      blob,
      "prog." +
        naberthermProgramNumber.value.toLocaleString("en-US", {
          minimumIntegerDigits: 2,
          useGrouping: false,
        }) +
        ".xml"
    );
  };

  const actions = () => (
    <React.Fragment>
      <Button
        variant="outline"
        disabled={my_segments.length === 0}
        onClick={() => {
          saveExportedFile();
        }}
      >
        Export
      </Button>
      <Button variant="outline" onClick={() => navigate(-1)}>Cancel</Button>
    </React.Fragment>
  );

  const renderContent = () => {
    if (!firing || !segments || !kiln) {
      return <div>Loading...</div>;
    }
    if (my_segments.length === 0) {
      return <div>This firing has no segments. There's no point exporting this!</div>;
    }
    return (
      <React.Fragment>
        <div>
          <p>
            <b>
              Warning!!! This hasn't been tested on real kilns yet. Don't be upset if the Kiln
              doesn't accept it, or freaks out and melts itself, or the controller just crashes.
            </b>
          </p>
          <p>
            You'll need to take this generated file, and place it in a directory called 'IMPORT' on
            the root directory of your USB stick.
          </p>
        </div>
        <p />
        <div>Name: {firing.name}</div>
        {kiln.manufacturer === "Nabertherm" && (
          <div>
            <form name="programNumber">
              <span>Program Number: {naberthermProgramNumber.value}</span>
              <p />
              <Slider
                max={10}
                min={1}
                step={1}
                value={[naberthermProgramNumber.value]}
                onValueChange={([value]) => setNaberthermProgramNumber({ value })}
                className="w-64 mt-2"
              />
            </form>
          </div>
        )}
      </React.Fragment>
    );
  };

  return (
    <Modal
      title="Export Firing"
      content={renderContent()}
      actions={actions()}
      onDismiss={() => navigate(-1)}
    />
  );
};

export default FiringExportPage;
